import React from 'react'
import { motion } from 'framer-motion';
import { Grid, PageTitle } from '../../styles/GlobalTheme/GlobalStyledComponents';
import { Content } from './StyledComponents';
// import { Items, Item, ItemIcon, ItemTitle, ItemText, Title, Text } from './StyledComponents';
import PageHeader from '../../components/PageHeader'
import { servicesData } from '../../data/websiteData';
import TextAnimation from "react-animate-text";
import Fade from 'react-reveal/Fade';

const index = ({match}) => {
    let {id} = match.params;
    return (
        <>
            <motion.div
                initial={{opacity: 0.5}}
                animate={{opacity: 1}}
                exit={{opacity: 0.5}}
            >
                <PageHeader title={servicesData[id].title} image={servicesData[id].headerImage}></PageHeader>
                <Grid mb="63">
                    <PageTitle>{servicesData[id].pageTitle}</PageTitle>
                </Grid>
                <Grid mb="105" mt="63">
                    <Fade bottom cascade duration={1000}>
                        <Content>{servicesData[id].content}</Content>
                    </Fade>
                </Grid>
            </motion.div>
        </>
    )
}

export default index
